import React, { useState, useEffect } from 'react';
import apiClient from '../../utils/axiosPetition';
import { alertaGeneral } from '../../utils/alertas';
import Modal from 'react-modal';
Modal.setAppElement('#root'); // Para accesibilidad del modal


const OfficeModal = ({ isOpen, onClose, onSave }) => {
    const initialFormState = {
        name: '',
        department: '',
        departmentName: '',
        mainCity: '',
        code: '',
        address: '',
        phone: '',
        email: '',
        zone: '',
        attentionLevel: '',
        complexity: ''
    };

    const [formData, setFormData] = useState(initialFormState);
    const [departments, setDepartments] = useState([]);
    const [cities, setCities] = useState([]);

    useEffect(() => {
        if (isOpen) {
            // Fetch departments when modal opens
            const fetchDepartments = async () => {
                try {
                    const response = await apiClient.get(`/api/clinic/departments`);
                    setDepartments(response.data);
                } catch (error) {
                    console.error('Error fetching departments:', error);
                }
            };

            fetchDepartments();
        } else {
            setFormData(initialFormState);
        }
    }, [isOpen]);

    useEffect(() => {
        if (formData.department) {
            // Fetch municipalities when a department is selected
            const fetchCities = async () => {
                if (formData.department) {
                    try {
                        const response = await apiClient.get(`/api/clinic/cities/${formData.department}`);
                        setCities(response.data);
                    } catch (error) {
                        console.error('Error fetching cities:', error);
                    }
                }
            };

            fetchCities();
        } else {
            setCities([]);
        }
    }, [formData.department]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(name, value);
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const handleDepartmentChange = (event) => {
        const selectedId = event.target.value;
        const selectedDepartment = departments.find(dept => dept._id === selectedId);

        setFormData({
            ...formData,
            department: selectedId, // ID del departamento
            departmentName: selectedDepartment ? selectedDepartment.departamento : '', // Nombre del departamento
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.mainCity || !formData.complexity || !formData.attentionLevel || !formData.zone) {
            alertaGeneral({
                title: 'Complete los campos son obligatorios',
                isError: true,
            });
            return; // Salir de la función para evitar el guardado
        }
        onSave(formData);
        setFormData(initialFormState); // Limpiar el formulario después de guardar
        onClose();
    };

    if (!isOpen) return null;

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className="w-[60%] mx-auto bg-white p-6 rounded-lg shadow-lg text-center border border-[#6e787aff] focus:outline-none"
            overlayClassName="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-[10]"
        >
            <div className="bg-white w-full overflow-y-auto">
                <h2 className="text-2xl text-left text-[#205087ff] font-bold mb-4">Agregar sede</h2>
                <form onSubmit={handleSubmit}>
                    <div className="text-left grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="form-group">
                            <label className="form-label">Nombre de la Sede *</label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Nombre de la Sede"
                                className="form-input"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Departamento *</label>
                            <select
                                name="department"
                                value={formData.department}
                                onChange={handleDepartmentChange}
                                className="form-input"
                                required
                            >
                                <option value="">Selecciona</option>
                                {departments.map(department => (
                                    <option key={department._id} value={department._id}>
                                        {department.departamento}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="form-label">Ciudad *</label>
                            <select
                                name="mainCity"
                                value={formData.mainCity}
                                onChange={handleChange}
                                className="form-input"
                                required
                            >
                                <option value="">Selecciona Ciudad</option>
                                {cities.length > 0 ? (
                                    cities.map((city, index) => (
                                        <option key={index} value={city}>
                                            {city}
                                        </option>
                                    ))
                                ) : (
                                    <option value="">No hay ciudades disponibles</option>
                                )}
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="form-label">Código *</label>
                            <input
                                type="text"
                                name="code"
                                value={formData.code}
                                onChange={handleChange}
                                placeholder="Código de la sede"
                                className="form-input"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Dirección *</label>
                            <input
                                type="text"
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                placeholder="Dirección"
                                className="form-input"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Teléfono *</label>
                            <input
                                type="text"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="Teléfono"
                                className="form-input"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Correo electrónico *</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Correo electrónico"
                                className="form-input"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Zona *</label>
                            <select
                                name="zone"
                                value={formData.zone}
                                onChange={handleChange}
                                className="form-input"
                                required
                            >
                                <option value="">Selecciona zona</option>
                                <option value="rural">Rural</option>
                                <option value="urbana">Urbana</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="form-label">Nivel de atención *</label>
                            <select
                                name="attentionLevel"
                                value={formData.attentionLevel}
                                onChange={handleChange}
                                className="form-input"
                                required
                            >
                                <option value="">Selecciona nivel</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="form-label">Complejidad *</label>
                            <select
                                name="complexity"
                                value={formData.complexity}
                                onChange={handleChange}
                                className="form-input"
                                required
                            >
                                <option value="">Selecciona complejidad</option>
                                <option value="Baja">Baja</option>
                                <option value="Mediana">Mediana</option>
                                <option value="Alta">Alta</option>
                            </select>
                        </div>
                    </div>
                    <div className="flex justify-center gap-4 mt-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="button-gray"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="button-send"
                        >
                            Agregar
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default OfficeModal;
